document.addEventListener('DOMContentLoaded', function() {
    var searchToggle = document.getElementById('site-search-toggle');
    var searchDropdown = document.getElementById('search-dropdown');
    var searchIconClosed = document.getElementById('search-icon-closed');
    var searchIconOpen = document.getElementById('search-icon-open');

    searchToggle.addEventListener('click', function(event) {
        var isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
        searchDropdown.classList.toggle('open');
        searchDropdown.setAttribute('aria-hidden', isExpanded);
        event.stopPropagation(); 

        // Toggle SVG icons
        if (isExpanded) {
            searchIconClosed.style.display = 'block';
            searchIconOpen.style.display = 'none';
        } else {
            searchIconClosed.style.display = 'none';
            searchIconOpen.style.display = 'block';
        }
    });

    document.addEventListener('click', function(event) {
        var isExpanded = searchToggle.getAttribute('aria-expanded') === 'true';
        if (isExpanded && !searchDropdown.contains(event.target) && event.target !== searchToggle) {
            searchToggle.setAttribute('aria-expanded', 'false');
            searchDropdown.classList.remove('open');
            searchDropdown.setAttribute('aria-hidden', 'true');
            searchIconClosed.style.display = 'block';
            searchIconOpen.style.display = 'none';
        }
    });
});
